// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".override-menu {\n  top: var(--menuY) !important;\n  left: var(--menuX) !important;\n  position: absolute !important;\n}", ""]);
// Exports
module.exports = exports;
